import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';
import GoogleCustomerReviewsOptIn from '../components/GoogleCustomerReviewsOptIn';
import { readLastInquiry } from '../utils/orderCompletion';
import './InquiryConfirmed.css';

const InquiryConfirmed = () => {
  const location = useLocation();
  const inquiry = useMemo(
    () => location.state?.inquiry || readLastInquiry(),
    [location.state]
  );

  if (!inquiry?.inquiryId) {
    return (
      <div className="inquiry-confirmed-page">
        <div className="inquiry-confirmed-container inquiry-confirmed-empty">
          <h1>No inquiry found</h1>
          <p>We could not find a recent availability check.</p>
          <Link to="/" className="inquiry-confirmed-btn primary">Back to home</Link>
        </div>
      </div>
    );
  }

  const whatsappUrl = location.state?.whatsappUrl || inquiry.whatsappUrl || '#';
  const showGcr = Boolean(inquiry.gcrOptInEnabled && inquiry.email && inquiry.surveyConsent);
  const gcrOrder = showGcr
    ? {
        orderId: inquiry.inquiryId,
        email: inquiry.email,
        deliveryCountry: inquiry.deliveryCountry || 'KE',
        estimatedDeliveryDate: inquiry.estimatedDeliveryDate,
      }
    : null;

  return (
    <div className="inquiry-confirmed-page">
      {gcrOrder && <GoogleCustomerReviewsOptIn order={gcrOrder} />}
      <div className="inquiry-confirmed-container">
        <div className="inquiry-confirmed-card">
          <h1 className="inquiry-confirmed-title">Availability check saved</h1>
          <p className="inquiry-confirmed-subtitle">
            Your reference is saved. Open WhatsApp to confirm availability with the store.
          </p>
          <div className="inquiry-confirmed-ref">Reference: {inquiry.inquiryId}</div>
          {inquiry.productName && (
            <p className="inquiry-confirmed-product">{inquiry.productName}</p>
          )}
          <div className="inquiry-confirmed-actions">
            <a
              href={whatsappUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="inquiry-confirmed-btn primary"
            >
              Open WhatsApp
            </a>
            <Link to="/" className="inquiry-confirmed-btn secondary">
              Continue browsing
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InquiryConfirmed;
